import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycSignRoutingModule } from './kyc-sign-routing.module';
import { KycSignComponent } from './kyc-sign.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NzIconModule, NzStepsModule, NzTableModule, NzTabsModule, NzUploadModule} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {SlickCarouselModule} from 'ngx-slick-carousel';


@NgModule({
  declarations: [KycSignComponent],
  imports: [
    CommonModule,
    KycSignRoutingModule,
    TranslateModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NzStepsModule,
    NzTableModule,
    NzTabsModule,
    NzUploadModule,
    NgxExtendedPdfViewerModule,
    NzIconModule,
    SlickCarouselModule
  ]
})
export class KycSignModuleEnterprise { }
